











































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";

class logs {
    log_id!:number;
    user_id!:number;
    text!:string;
    action!:string;
    created_at!:string;
    name!:string;
    lastname!:string;
}
@Component({
    components: {
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class Log extends  Vue{
    items : logs[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "logs";
    action:string = this.baseAction;
    data : logs = new logs();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "log_id"
        },
        {text: "Kullanıcı", value: "name"},
        {text: "Aksiyon", value: "action"},
        {text: "İşlem", value: "text"},
        {text: "Tarih", value: "created_at"},
        {text: "İşlemler", value: "actions"}
    ];
    goUser(item:logs){
        this.$store.dispatch("go","/genel/users/"/*+item.user_id*/);
    }
    edit(item:logs){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.log_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new logs();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
